export const flexDirectionValues = {
  ROW: 'row',
  ROW_REVERSE: 'row-reverse',
};

export const flexWrapValues = {
  WRAP: 'wrap',
  WRAP_REVERSE: 'wrap-reverse',
};
